module.exports = __webpack_public_path__ + "static/img/de.89d188c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/de.jpg
// module id = 1Z38
// module chunks = 15